import { createContext, useContext } from 'react';

import { useMainModalSmallScreenLayout } from './useMainModalSmallScreenLayout';

const OnboardingModalActionsCompactContext = createContext(false);

/**
 * True when the compact footer breakpoint is active. Steps call this above
 * {@link OnboardingModalActions}, so viewport detection is used alongside context.
 */
export function useOnboardingModalActionsCompact(): boolean {
  const compactFromContext = useContext(OnboardingModalActionsCompactContext);
  const compactFromViewport = useMainModalSmallScreenLayout();

  return compactFromContext || compactFromViewport;
}

export { OnboardingModalActionsCompactContext };
